import * as tslib_1 from "tslib";
import { Logger } from "../Misc/logger";
import { Observable } from "../Misc/observable";
import { Vector3, Color3 } from "../Maths/math";
import { Gizmo } from "./gizmo";
import { AxisDragGizmo } from "./axisDragGizmo";
import { UtilityLayerRenderer } from "../Rendering/utilityLayerRenderer";
/**
 * Gizmo that enables dragging a mesh along 3 axis
 */

var PositionGizmo =
/** @class */
function (_super) {
  tslib_1.__extends(PositionGizmo, _super);
  /**
   * Creates a PositionGizmo
   * @param gizmoLayer The utility layer the gizmo will be added to
   */


  function PositionGizmo(gizmoLayer) {
    if (gizmoLayer === void 0) {
      gizmoLayer = UtilityLayerRenderer.DefaultUtilityLayer;
    }

    var _this = _super.call(this, gizmoLayer) || this;
    /** Fires an event when any of it's sub gizmos are dragged */


    _this.onDragStartObservable = new Observable();
    /** Fires an event when any of it's sub gizmos are released from dragging */

    _this.onDragEndObservable = new Observable();
    _this.xGizmo = new AxisDragGizmo(new Vector3(1, 0, 0), Color3.Red().scale(0.5), gizmoLayer);
    _this.yGizmo = new AxisDragGizmo(new Vector3(0, 1, 0), Color3.Green().scale(0.5), gizmoLayer);
    _this.zGizmo = new AxisDragGizmo(new Vector3(0, 0, 1), Color3.Blue().scale(0.5), gizmoLayer); // Relay drag events

    [_this.xGizmo, _this.yGizmo, _this.zGizmo].forEach(function (gizmo) {
      gizmo.dragBehavior.onDragStartObservable.add(function () {
        _this.onDragStartObservable.notifyObservers({});
      });
      gizmo.dragBehavior.onDragEndObservable.add(function () {
        _this.onDragEndObservable.notifyObservers({});
      });
    });
    _this.attachedMesh = null;
    return _this;
  }

  Object.defineProperty(PositionGizmo.prototype, "attachedMesh", {
    get: function get() {
      return this.xGizmo.attachedMesh;
    },
    set: function set(mesh) {
      if (this.xGizmo) {
        this.xGizmo.attachedMesh = mesh;
        this.yGizmo.attachedMesh = mesh;
        this.zGizmo.attachedMesh = mesh;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PositionGizmo.prototype, "updateGizmoRotationToMatchAttachedMesh", {
    get: function get() {
      return this.xGizmo.updateGizmoRotationToMatchAttachedMesh;
    },
    set: function set(value) {
      if (this.xGizmo) {
        this.xGizmo.updateGizmoRotationToMatchAttachedMesh = value;
        this.yGizmo.updateGizmoRotationToMatchAttachedMesh = value;
        this.zGizmo.updateGizmoRotationToMatchAttachedMesh = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PositionGizmo.prototype, "snapDistance", {
    get: function get() {
      return this.xGizmo.snapDistance;
    },

    /**
     * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
     */
    set: function set(value) {
      if (this.xGizmo) {
        this.xGizmo.snapDistance = value;
        this.yGizmo.snapDistance = value;
        this.zGizmo.snapDistance = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PositionGizmo.prototype, "scaleRatio", {
    get: function get() {
      return this.xGizmo.scaleRatio;
    },

    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */
    set: function set(value) {
      if (this.xGizmo) {
        this.xGizmo.scaleRatio = value;
        this.yGizmo.scaleRatio = value;
        this.zGizmo.scaleRatio = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Disposes of the gizmo
   */

  PositionGizmo.prototype.dispose = function () {
    this.xGizmo.dispose();
    this.yGizmo.dispose();
    this.zGizmo.dispose();
    this.onDragStartObservable.clear();
    this.onDragEndObservable.clear();
  };
  /**
   * CustomMeshes are not supported by this gizmo
   * @param mesh The mesh to replace the default mesh of the gizmo
   */


  PositionGizmo.prototype.setCustomMesh = function (mesh) {
    Logger.Error("Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.yGizmo, gizmo.zGizmo)");
  };

  return PositionGizmo;
}(Gizmo);

export { PositionGizmo };